import React, {createContext, useState} from 'react';

import {
  MODAL_ADD_PHONE,
  MODAL_ERROR,
  MODAL_VOTE_CONFIRM,
  MODAL_VOTE_SUCCESS} from '../constants';
import {AddPhoneModal} from '../modals/AddPhoneModal';
import CenterModal from '../modals/CenterModal';
import ConfirmVoteModalBody from '../modals/ConfirmVoteModalBody';
import ErrorModalBody from '../modals/ErrorModalBody';
import SuccessVotedModalBody from '../modals/SuccessVotedModalBody';

export const ModalContext = createContext();

export const ModalProvider = ({callAuthModal, children}) => {
  const [openModal, setOpenModal] = useState({isOpen: false});

  const renderModal = () => {
    switch (openModal.type) {
      case MODAL_ERROR: return <ErrorModalBody {...openModal.params} />;
      case MODAL_VOTE_SUCCESS: return <SuccessVotedModalBody {...openModal.params} />;
      case MODAL_VOTE_CONFIRM: return <ConfirmVoteModalBody {...openModal.params} setModal={setOpenModal} />;
      case MODAL_ADD_PHONE: return <AddPhoneModal onClose={() => setOpenModal({isOpen: false})} />;
      default: return <ErrorModalBody {...openModal.params} />;
    }
  };

  return (
    <ModalContext.Provider value={{setOpenModal, openModal, callAuthModal}}>
      {children}
      <CenterModal isOpen={openModal.isOpen} setModal={setOpenModal} isSecondary={openModal.type === MODAL_ADD_PHONE}>
        {renderModal()}
      </CenterModal>
    </ModalContext.Provider>
  );
};
